import React from 'react';
import { useSelector } from 'react-redux';
import EquipServiceCard from './CardTypes/EquipServiceCard';
import ActionCard from './CardTypes/ActionCard';
import ServiceCard from './CardTypes/ServiceCard';
import MaintenanceCard from './CardTypes/MaintenanceCard';
import FutureServiceCard from './CardTypes/FutureServiceCard';


const EventModalCard = () => {

  const modalData = useSelector(state => state.calendars.modalData)
  const modalType = useSelector(state => state.calendars.modalType);
  const modalStage = useSelector(state => state.calendars.modalStage);

  const cardLoader = (type) => {
    switch (type) {
      case 'action':
        return (modalData.map(data => <ActionCard key={data._id} data={data} stage={modalStage}/>));
      case 'maintenance':
        return (modalData.map(data => <MaintenanceCard key={data._id} data={data} stage={modalStage}/>));
      case 'service':
        if (modalStage === 'done') {
          return (modalData.map(data => <ServiceCard key={data._id} data={data} stage={modalStage}/>));
        } else {
          return (modalData.map(data => {
            if (!data.equipment) return (<EquipServiceCard key={data._id} data={data} stage={modalStage}/>);
            return (<FutureServiceCard key={data._id} data={data} stage={modalStage}/>);
          }))
        }
      default: return <></>
    }
  }

  return (
    cardLoader(modalType)
  );
}



export default EventModalCard;

